// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"684":"fc7252fe","741":"f49fa574","787":"243155ba","908":"0139362c"}[chunkId] + ".chunk.js";
};